import React, { useEffect, FC } from "react";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";
import {
    Block,
    BlockDes,
    BlockHead,
    BlockHeadContent,
    BlockTitle,
    PreviewCard,
    BlockBetween,
    Button,
    Icon
} from "../../../components/Component";
import { Steps, Step } from "react-step-builder";
import { useForm, FormProvider } from "react-hook-form";
import ComplianceandCertifications from "./ComplianceandCertifications";
import ClientInformation from "./ClientInformation";
import ContactInformation from "./ContactInformation";
import EmergencyResponseandContingencyPlans from "./EmergencyResponseandContingencyPlans";
import Header from "./Header";
import { useNavigate } from 'react-router-dom';

const config = {
    before: Header as React.ComponentType<{}> as () => React.ReactElement,
};

const AddClients: React.FC = (props: any) => {
    const navigate = useNavigate();
    const formMethods = useForm({
        mode: "onSubmit",
    });
    useEffect(() => {
    }, []);

    const backList = () => {
        navigate(`/clients`);
    }

    return (
        <React.Fragment>
            <Head title="Create Clients" />
            <Content>
                <BlockHead size="lg">
                    <BlockBetween>
                        <BlockHeadContent>
                            <BlockTitle tag="h4">Create Clients</BlockTitle>
                            <BlockDes>Onboard Clients platform, collecting essential information to create Clients profiles.</BlockDes>
                        </BlockHeadContent>
                        <BlockHeadContent>
                            <Button color="primary" className="btn-dim" onClick={() => backList()}>
                                <Icon name="menu-alt-r"></Icon>
                                <span>List of Clients</span>
                            </Button>
                        </BlockHeadContent>
                    </BlockBetween>
                </BlockHead>
                <Block>
                    <PreviewCard className={'cardBox'} bodyClass="card-inner-xl">
                        <div className="nk-wizard nk-wizard-simple is-alter wizard clearfix"> 
                            <FormProvider {...formMethods}>
                                <Steps config={config}>
                                    <Step component={ClientInformation} />
                                    <Step component={ContactInformation} />
                                    <Step component={ComplianceandCertifications} />
                                    <Step component={EmergencyResponseandContingencyPlans} />
                                </Steps>
                            </FormProvider>
                        </div>
                    </PreviewCard>
                </Block>
            </Content>
        </React.Fragment>
    );
};
export default AddClients;
